import React, { useEffect, useState } from 'react';
import { getStorySettings, login } from '../api/api';

function StorySetting() {
  const [storySettings, setStorySettings] = useState([]);

  useEffect(() => {
    async function fetchStorySettings() {
      try {
        let token = localStorage.getItem('access_token');
        if (!token) {
          const loginResponse = await login(); // 假设 login 函数返回一个包含 token 的对象
          console.log(loginResponse)
          token = loginResponse.data.access_token;
          localStorage.setItem('access_token', token);

          const data = await getStorySettings(token);
          setStorySettings(data.slice(0, 5)); // 只要前 5 个
          console.log(data.slice(0, 5));     
        } else {
          const data = await getStorySettings(token);
          setStorySettings(data.slice(0, 5)); // 只要前 5 个
          console.log(data.slice(0, 5));         
        }

      } catch (error) {
        console.error('Error fetching story settings:', error);
      }
    }

    fetchStorySettings();
  }, []);

    function handleStorySettingClick(storySetting) {
        storySetting.checked = !storySetting.checked;
        setStorySettings([...storySettings]);

        // 获取所有选中的故事设定名称
        const selectedStorySettingNames = storySettings
        .filter(s => s.checked)
        .map(s => s.name);

        // 将选中的故事设定名称存储到 localStorage
        localStorage.setItem('selectedStorySettingNames', JSON.stringify(selectedStorySettingNames));
    }

  return (
    <div style={{
      backgroundImage: 'url(/images/background.png)', // 使用相对于 public 目录的路径
      backgroundSize: 'cover',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      overflow: 'hidden' // 设置超出隐藏
    }}>
      <img src="/images/title.png" alt="Title" style={{
        position: 'absolute',
        top: '10px',
        left: '30px',
        width: '60px'
      }} />
      <div style={{
        position: 'absolute',
        top: '25px',
        right: '40px',
        fontWeight: 'bold',
        fontSize: '18px'
      }}>
        故事设定选择
      </div>

      <div 
        style={{ 
          position:'fixed',
          top:'80px',
          fontSize: '12px', 
          marginBottom: '10px', 
          fontWeight: 500 
        }}
      >
        请选择在短剧中需要出现的故事设定，故事设定可以选择多个
      </div>

    <div style={{
      width:'300px',
      display: 'flex',
      flexWrap: 'wrap',
      position: 'fixed',
      alignItems:'center',
      justifyContent:'start',
      marginLeft:'30px',
      left: '50%',
      transform: 'translateX(-50%)',
      top:'0px',
      marginTop: '120px',
    }}>
      {storySettings.map(storySetting => (
        <div 
          key={storySetting.id}
          style={{
            width: '60px',
            height: '40px',
            backgroundColor: storySetting.checked ? '#F65555' : 'white',
            border: '1px solid #ccc',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
            borderRadius: '15px',
            padding: '20px',
            margin: '10px'
          }}
          onClick={() => handleStorySettingClick(storySetting)}
        >
          <span style={{ fontSize: '16px', marginTop: '5px' }}>{storySetting.name}</span>
        </div>
      ))}
    </div>
    <button 
          onClick={() => window.location.href = '/world-view'}
          style={{
            position: 'fixed',
            bottom: '50px',
            padding: '10px 20px',
            fontSize: '16px',
            width: '55%',
            height: '80px',
            backgroundColor: 'black',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}>
          下一步
    </button>
    </div>
  );
}

export default StorySetting;
